import { MessageEnum } from './message.enum';

export class Message {
      code: string;
      body: string;
      title: string;
      type: MessageEnum;
}
